// extracted by mini-css-extract-plugin
module.exports = {"default":"rule_default__lPCgb","basic":"rule_basic__OnHyR"};